<div class="side">
  <section class="side__section">
    <h3 class="side__title">Participantes</h3>
    <app-meeting-participants [participants]="meeting().participants" />
  </section>

  @if (interno()) {
    <!-- Card 3244: o que aconteceu com o bot e com a gravação, só para o time interno. -->
    <section class="side__section">
      <app-meeting-timeline [meetingId]="meeting().id" />
    </section>

    <section class="side__section">
      <h3 class="side__title">Sobre o bot</h3>
      <dl class="side__rows">
        <div>
          <dt>Origem</dt>
          <dd>
            {{ origem(meeting().source) }}
            @if (meeting().source === 'Manual') {
              <span class="side__muted">pedido em "Adicionar bot na call"</span>
            } @else if (nomesDasAgendas(meeting().calendarOwners); as nomes) {
              <!--
                Card 3221 (antes, a frase genérica "agenda de quem conectou a conta Microsoft"): quem
                tem a reunião na agenda conectada ao Cog, pelo nome. A lista vem do backend (card 3191),
                com a agenda de origem primeiro.
              -->
              <span class="side__muted">na agenda de {{ nomes }}</span>
              <ul class="side__calendars">
                @for (dono of meeting().calendarOwners; track dono.email ?? dono.name) {
                  <li>
                    <span class="side__calendar-name">
                      {{ dono.name }}
                      @if (dono.isOrigin) {
                        <span class="side__muted">· trouxe a reunião</span>
                      }
                    </span>
                    @if (dono.email && dono.email !== dono.name) {
                      <span class="side__muted">{{ dono.email }}</span>
                    }
                  </li>
                }
              </ul>
            } @else {
              <!-- Sem evento de calendário guardado ou sem a conexão: o backend não tem a quem atribuir. -->
              <span class="side__muted">não foi possível identificar de quem é a agenda</span>
            }
          </dd>
        </div>
      </dl>
    </section>
  }
</div>
